import { Controller } from "@hotwired/stimulus"
import Chartkick from "chartkick"

// Draws a Chartkick chart from data attributes (see ChartsHelper#chart_tag).
//
// Chartkick's Rails helpers emit an inline <script> per chart. The
// Content-Security-Policy allows no inline scripts, and a nonce would not
// help: Turbo Drive re-creates inline scripts from a fetched page with that
// page's nonce while the document still runs under the first response's
// policy, so a nonced chart would only draw on a full page load.
export default class extends Controller {
  static values = {
    type: { type: String, default: "LineChart" },
    data: Object,
    options: { type: Object, default: {} }
  }

  connect() {
    this.chart = new Chartkick[this.typeValue](this.element, this.dataValue, this.optionsValue)
  }

  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }
}
